import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/TeacherList.vue')
const Edit = () => import('../views/TeacherEdit.vue')

export const listRoute: RouteConfig = {
  path: '/teacher-list',
  name: 'teacher_list',
  component: List,
  meta: {
    title: '教师管理',
  },
}

export const editRoute: RouteConfig = {
  path: '/teacher-edit',
  name: 'teacher_edit',
  component: Edit,
  meta: {
    title: '添加教师',
  },
}

export default [listRoute, editRoute]

export function navigateToTeacherList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToTeacherEdit(router: VueRouter, init = '') {
  router.push({ name: editRoute.name, query: { init } })
}
